var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMovable01 = function SvgMovable01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "movable-01_svg2__a",
    x1: -24.65,
    x2: 142.35,
    y1: 88.43,
    y2: -46.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#movable-01_svg2__a",
    id: "movable-01_svg2__b",
    x1: 14.46,
    x2: 181.46,
    y1: 136.81,
    y2: 1.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#movable-01_svg2__a",
    id: "movable-01_svg2__c",
    x1: 53.58,
    x2: 220.58,
    y1: 185.19,
    y2: 50.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#movable-01_svg2__a",
    id: "movable-01_svg2__d",
    x1: 6.97,
    x2: 173.97,
    y1: 127.54,
    y2: -7.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#movable-01_svg2__a",
    id: "movable-01_svg2__e",
    x1: 46.08,
    x2: 213.08,
    y1: 175.92,
    y2: 40.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#movable-01_svg2__a",
    id: "movable-01_svg2__f",
    x1: 85.19,
    x2: 252.19,
    y1: 224.31,
    y2: 89.31
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 20,
    r: 20,
    style: {
      fill: "url(#movable-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 100,
    r: 20,
    style: {
      fill: "url(#movable-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 180,
    r: 20,
    style: {
      fill: "url(#movable-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 20,
    r: 20,
    style: {
      fill: "url(#movable-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 100,
    r: 20,
    style: {
      fill: "url(#movable-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 180,
    r: 20,
    style: {
      fill: "url(#movable-01_svg2__f)"
    }
  }));
};
export default SvgMovable01;